// Módulo de voz (V3) free‑tier usando Web Speech API (STT/TTS)
// No modifica la UI: expone window.voice con start/stop/speak/cancel y eventos.

function getRecognition() {
  const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (!SR) return null;
  const rec = new SR();
  rec.continuous = true;
  rec.interimResults = true;
  return rec;
}

function speakText(text, { lang = 'en', rate = 1, pitch = 1, voiceHint } = {}) {
  if (!('speechSynthesis' in window)) return { cancel: ()=>{} };
  const u = new SpeechSynthesisUtterance(text);
  u.lang = lang; u.rate = rate; u.pitch = pitch;
  if (voiceHint && window.speechSynthesis.getVoices) {
    const voices = window.speechSynthesis.getVoices();
    const match = voices.find(v => v.lang?.toLowerCase().startsWith(lang) || v.name?.toLowerCase().includes(String(voiceHint).toLowerCase()));
    if (match) u.voice = match;
  }
  window.speechSynthesis.cancel();
  window.speechSynthesis.speak(u);
  return { cancel: () => window.speechSynthesis.cancel() };
}

export function setupVoiceGlobals() {
  try {
    const rec = getRecognition();
    let active = null;

    const api = {
      supported: {
        stt: Boolean(rec),
        tts: Boolean('speechSynthesis' in window)
      },
      start: ({ lang = (window.__UI_LANG__ || 'en'), interim = true } = {}) => {
        if (!rec) return false;
        if (active) api.stop();
        rec.lang = lang; rec.interimResults = interim;
        rec.onresult = (e) => {
          let finalText = ''; let interimText = '';
          for (let i = e.resultIndex; i < e.results.length; i++) {
            const tr = e.results[i][0].transcript;
            if (e.results[i].isFinal) finalText += tr; else interimText += tr;
          }
          window.dispatchEvent(new CustomEvent('voice:result', { detail: { finalText, interimText, lang } }));
        };
        rec.onerror = (e) => { window.dispatchEvent(new CustomEvent('voice:error', { detail: e })); };
        rec.onend = () => { window.dispatchEvent(new CustomEvent('voice:end', { detail: {} })); active = null; };
        rec.start(); active = rec; return true;
      },
      stop: () => { try { if (active) active.stop(); } catch {} active = null; },
      speak: (text, opts) => speakText(text, opts),
      cancel: () => { try { window.speechSynthesis?.cancel(); } catch {} }
    };
    // Exponer global
    window.voice = api;
    return api;
  } catch {
    return null;
  }
}
